import React from 'react';
import { AttachmentForm } from './Attachments';
import { EntityValue } from './entityValue';
import { AllEntityTypes, PriorityTypes } from 'models/Task';
import { AdminsSelect } from 'components/common/adminsSelect';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { Button, Col, DatePicker, Divider, Form, Input, Row, Select, Typography, SunTextEditor } from 'components';
import { useAdd } from './useAdd';
import './tiptapEditor.scss';
import 'react-quill/dist/quill.snow.css';
import styles from './../styles.module.scss';
import dayjs from 'dayjs';

const { TextArea } = Input;

export const AddTask: React.FC = () => {
  const { hasAccess } = useAccessControl();
  const {
    form,
    onFinish,
    onCancel,
    attachments,
    setAttachments,
    description,
    setDescription,
    disableSaveBtn,
    setAttachmentType,
    fileList,
    setFileList,
    attachmentType,
    handleFormChange,
    createIsLoading,
    entityName,
  } = useAdd();

  return (
    <Row justify={'end'} gutter={[0, 32]}>
      <Col span={24}>
        <Row gutter={[0, 24]} justify={'center'}>
          <Col span={24}>
            <Typography.Title className={styles.add_edit_title} level={2}>
              Add Task
            </Typography.Title>
          </Col>
          <Col span={24} className={styles.form_container}>
            <Form
              onValuesChange={handleFormChange}
              form={form}
              requiredMark={false}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item label="Assign To*" name="assignedTo" rules={[{ required: true }]}>
                    <AdminsSelect size={'large'} />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Priority*"
                    name="priorityLevel"
                    rules={[{ required: true }]}
                    initialValue="STANDARD"
                  >
                    <Select size={'large'} options={PriorityTypes} />
                  </Form.Item>
                </Col>

                {!entityName && (
                  <>
                    <Col span={12}>
                      <Form.Item label="Entity" name="entityType">
                        <Select
                          size={'large'}
                          placeholder="Select entity"
                          options={Object.values(AllEntityTypes).filter((i) => hasAccess(i.permission))}
                        />
                      </Form.Item>
                    </Col>

                    <Form.Item noStyle shouldUpdate={(prev, curr) => prev.entityType !== curr.entityType}>
                      {({ getFieldValue }) => {
                        const entity = getFieldValue('entityType');
                        return (
                          <Col span={12}>
                            <EntityValue entity={entity} />
                          </Col>
                        );
                      }}
                    </Form.Item>
                  </>
                )}

                <Col span={24}>
                  <Form.Item
                    label="Summary*"
                    name="summary"
                    rules={[{ required: true, message: 'Please enter task summary' }]}
                  >
                    <TextArea placeholder="Enter task summary" />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item label="Description*">
                    <SunTextEditor value={description} onChange={setDescription} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                <Col span={12}>
                  <Form.Item
                    label="Due Date*"
                    name="dueDate"
                    rules={[{ required: true, message: 'Please select due date' }]}
                  >
                    <DatePicker
                      size={'large'}
                      showTime={{ format: 'HH:mm', defaultValue: dayjs('00:00', 'HH:mm'), showSecond: false }}
                      format="YYYY-MM-DD HH:mm"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Col span={24} className={'margin-t-20'}>
                <Typography.Title level={5} style={{ color: '#05796B', margin: 0 }}>
                  Attachments
                </Typography.Title>
              </Col>
              <Col span={24}>
                <AttachmentForm
                  attachments={attachments}
                  setAttachmentType={setAttachmentType}
                  fileList={fileList}
                  setAttachments={setAttachments}
                  setFileList={setFileList}
                  attachmentType={attachmentType}
                />
              </Col>
            </Form>
          </Col>
        </Row>
      </Col>
      <Col offset={1} span={23}>
        <Divider style={{ marginBottom: 32 }} className={styles.divider} />
      </Col>
      <Col flex={'328px'}>
        <Row wrap={false} className="gap-8">
          <Button block size="large" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            block
            size="large"
            disabled={disableSaveBtn}
            type="primary"
            loading={createIsLoading}
            onClick={() => {
              form?.submit();
            }}
          >
            Add
          </Button>
        </Row>
      </Col>
    </Row>
  );
};
